import useOrganization from './useOrganization'

export default function useOrganizationIsMultiRegion() {
  const organization = useOrganization()
  return Boolean(organization?.organizationMetadata?.modules?.region)
}
